import React from 'react';
import BottomWebs from "./BottomWebs"
import "../../../App.css";
import "./portfolio.css"


const Portfolio = () => {

    return (
        <div className="Portfolio column" id='PortfolioScroll'>
            <h1 >Portfolio</h1>
            <BottomWebs />
        </div>
    )
}

export default Portfolio;